import { memo } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { PLAN_TEXT } from '../planPageRevampTypography';
import { accent, text as textToken } from '../planPageRevampUi';

/**
 * Shown in the input panel before any driver is selected from the left list.
 * Previously this slot fell through to DimesionPage with no driver, which
 * fired fetchPropertyValue with an undefined id and sat on FullScreenLoader
 * forever — looked like a stuck spinner, not an empty state.
 */
const RevampInputEmptyState = () => (
  <Flex
    h='100%'
    w='100%'
    direction='column'
    alignItems='center'
    justifyContent='center'
    gap='16px'
    px='24px'
  >
    <Flex
      alignItems='center'
      justifyContent='center'
      w='56px'
      h='56px'
      borderRadius='full'
      bg={accent.subtle}
    >
      <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <path
          d='M9 11l3 3L22 4'
          stroke={accent.solid}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h11'
          stroke={accent.solid}
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </Flex>
    <Flex direction='column' alignItems='center' gap='4px'>
      <Text {...PLAN_TEXT.bodyMedium} color={textToken.primary}>
        Select an input to get started
      </Text>
      <Text {...PLAN_TEXT.body} color={textToken.secondary} textAlign='center' maxW='280px'>
        Pick a driver from the panel on the left to view and edit its values.
      </Text>
    </Flex>
  </Flex>
);

export default memo(RevampInputEmptyState);
